import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@mui/material';
import {
  EditOutlined as RecordIcon,
  LockOutlined as LockIcon,
  PeopleOutline as PeopleIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Card, Container, IconTile, Section, SectionHeader } from './primitives';
import { landing } from './tokens';

const items = [
  { key: 'bank', icon: <LockIcon /> },
  { key: 'readOnly', icon: <RecordIcon /> },
  { key: 'separate', icon: <PeopleIcon /> },
];

const PrivacySection: React.FC = () => {
  const { t } = useTranslation('landing');
  return (
    <Section sx={{ pb: { xs: 8, md: 12 } }}>
      <Container sx={{ display: 'flex', flexDirection: 'column', gap: 5.5 }}>
        <SectionHeader eyebrow={t('privacy.eyebrow')} title={t('privacy.title')} />
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(300px, 100%), 1fr))',
            gap: 2.5,
          }}
        >
          {items.map((item) => (
            <Card key={item.key} sx={{ gap: 1.5 }}>
              <IconTile>{item.icon}</IconTile>
              <Box component='h3' sx={{ fontSize: 21 }}>
                {t(`privacy.${item.key}.title`)}
              </Box>
              <Box component='p' sx={{ color: landing.ink2, lineHeight: 1.6 }}>
                {t(`privacy.${item.key}.text`)}
              </Box>
            </Card>
          ))}
        </Box>
        <Box component={RouterLink} to='/privacidade' sx={{ alignSelf: 'flex-start', color: landing.accent, fontWeight: 600 }}>
          {t('privacy.link')}
        </Box>
      </Container>
    </Section>
  );
};

export default PrivacySection;
